/**
 * Why sending for signature and marking as signed are switched off while another amendment of
 * the same schedule is out for signature or signed. The banner says the same at more length.
 */
export const AMENDMENT_OUT_FOR_SIGNATURE_REASON =
  'Another quote for this billing schedule is already out for signature or signed'

/** Under a recipient list whose signers can't be ticked for the same reason. */
export const AMENDMENT_OUT_FOR_SIGNATURE_SIGNERS_NOTE =
  'Another quote for this billing schedule is already out for signature or signed, so only CC recipients can be chosen.'
